import { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Actions, variantActionsProps } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMembersViewContext } from 'pages/settings/pages/members/pages/membersView/context/membersViewContext'
import { MembersTable } from 'pages/settings/pages/members/pages/membersView/ui/MembersTable/MembersTable'
import { getMembersActions, getMembersBulkActions } from 'pages/settings/pages/members/ui/actions'
import { getMembersColumns } from './columns'

const pinnedColumnIds = ['fullName']

export const ActiveMembersTab = observer(() => {
  const { fetchCounts, activeMembersStore } = useMembersViewContext()
  const entities = useEntitiesContext()
  const { init, tableStore, loading, search, setSearch, itemsRows, scrollToTopTrigger, loadData } =
    activeMembersStore

  useEffect(() => {
    init()
    return () => setSearch('')
  }, [])

  const columns = useMemo(() => getMembersColumns(), [])

  const rows = itemsRows.map((item) => {
    const { isPaygLocked } = item

    item.setActionsProps({
      actions: isPaygLocked
        ? []
        : getMembersActions(item, entities, { loadData, fetchCounts, tableStore }),
    })

    item.setDisabled(isPaygLocked)
    item.setCheckboxDisabled(isPaygLocked)

    return item
  })

  return (
    <MembersTable
      setSearch={setSearch}
      search={search}
      tableProps={{
        ariaLabel: 'ActiveMembersTable',
        rows,
        columns,
        loading,
        store: tableStore,
        pinnedColumnIds,
        scrollToTOpTrigger: scrollToTopTrigger,
        withCheckbox: true,
        withSelectAll: true,
        headerLeftContentProps: {
          actionsContent: (
            <Actions
              {...variantActionsProps.headerSmall}
              actions={getMembersBulkActions(tableStore.selectedRows, { tableStore, search })}
            />
          ),
        },
      }}
    />
  )
})
